import styled, { keyframes } from 'styled-components';
import { breakpoint } from '@aib/design-tokens';

const slide = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(-3500px, 0, 0);
  }
`;

const Clouds = styled.div`
  height: 400px;
  width: 3500px;
  position: absolute;
  display: none;

  @media (min-width: ${breakpoint.medium}) {
    display: block;
  }

  animation-name: ${slide};
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;

const CloudsPausable = styled(Clouds)`
  animation-play-state: ${(props) =>
    props.$playAnimation ? 'running' : 'paused'};
`;

export const Clouds1a = styled(CloudsPausable)`
  background: url('/mortgages/assets/clouds-1.svg') repeat-x;
  top: 15%;
  left: 0;
  animation-duration: 80s;
`;

export const Clouds1b = styled(CloudsPausable)`
  background: url('/mortgages/assets/clouds-1.svg') repeat-x;
  top: 15%;
  left: 3500px;
  animation-duration: 80s;
`;

export const Clouds2a = styled(CloudsPausable)`
  background: url('/mortgages/assets/clouds-2.svg') repeat-x;
  top: -5%;
  left: 0;
  animation-duration: 40s;
`;

export const Clouds2b = styled(CloudsPausable)`
  background: url('/mortgages/assets/clouds-2.svg') repeat-x;
  top: -5%;
  left: 3500px;
  animation-duration: 40s;
`;
